import React, { useState, useEffect } from 'react';
import { useStore } from '@store';
import { observer } from 'mobx-react-lite';
import { DateFilter } from '@components';
import { addCommas, removeNonNumeric } from '@helper';
import { transTypes } from '../../constant/statement';
const BankStatement = () => {
    const {
        BankStatementStore: {
            updateData,
            startDate,
            endDate,
            bankStatementDetails,
            getBankStatementDetails,
            reset,
        },
    } = useStore();
    const [defaultValue, setDefaultValue] = useState('0');
    useEffect(() => {
        getBankStatementDetails(defaultValue, startDate, endDate);
    }, [defaultValue, startDate, endDate]);
    useEffect(() => {
        return () => {
            reset({ startDate: '', endDate: '' });
        };
    }, []);
    return (
        <div>
            <h6 className="title fs-22 fw-bolder mb-3">對帳單明細</h6>

            <div className="filter-info d-sm-flex flex-nowrap justify-content-between align-items-center mb-2">
                <DateFilter
                    defaultValue={defaultValue}
                    data={bankStatementDetails}
                    setDefaultValue={setDefaultValue}
                    updateData={updateData}
                />
            </div>

            <div className="overflow-auto fs-15 scrol_sty">
                <table
                    cellSpacing={0}
                    className="table table_sty fix-first fs-6"
                >
                    <thead>
                        <tr>
                            <th className="fix">申請日期</th>
                            <th>申請編號</th>
                            <th>交易類別</th>
                            <th className="text-end">申請金額</th>
                            <th className="text-end">借貸手續費</th>
                            <th className="text-end">借款利息</th>
                            <th className="text-end">淨收付金額</th>
                            <th>擔保品代號</th>
                            <th>擔保品名稱</th>
                            <th>抵繳張數</th>
                            <th>退還張數</th>
                        </tr>
                    </thead>
                    <tbody>
                        {bankStatementDetails.map(
                            (
                                {
                                    applyDate,
                                    applyNo,
                                    transType,
                                    amount,
                                    charge,
                                    interest,
                                    netPayment,
                                    stockNo,
                                    stockName,
                                    offsetQty,
                                    backQty,
                                },
                                index
                            ) => {
                                return (
                                    <tr key={`bankStatementDetails ${index}`}>
                                        <td className="fix">{applyDate}</td>
                                        <td>{applyNo}</td>
                                        <td>
                                            {transTypes
                                                .filter(
                                                    i =>
                                                        i.transType ===
                                                        transType
                                                )
                                                .map(i => i.label)}
                                        </td>
                                        <td>
                                            <div className="text-end">
                                                {addCommas(
                                                    removeNonNumeric(amount)
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="text-end">
                                                {addCommas(
                                                    removeNonNumeric(charge)
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="text-end">
                                                {addCommas(
                                                    removeNonNumeric(interest)
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="text-end">
                                                {addCommas(netPayment)}
                                            </div>
                                        </td>
                                        <td>{stockNo}</td>
                                        <td>{stockName}</td>
                                        <td>{offsetQty}</td>
                                        <td>{backQty}</td>
                                    </tr>
                                );
                            }
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default observer(BankStatement);
